import { observer } from "mobx-react";
import { Paper, Table, TableBody, TableContainer } from "@material-ui/core";
import { HeadTable } from "../../../UI/Table";
import InstallmentRow from "./InstallmentRow";

const InstallmentsTable = observer(
  ({ store, onEditRowData, onDeleteRowData, onEditMaturityDate }) => (
    <TableContainer
      component={Paper}
      elevation={0}
      style={{ overflow: "scroll", height: "calc(99vh - 131px)" }}
    >
      <Table aria-label="collapsible table">
        <HeadTable
          columns={store.columns}
          actionColumn={true}
          actionWidth={140}
        />
        <TableBody>
          {store.rows.map((row: any) => (
            <InstallmentRow
              key={row.code}
              columns={store.columns}
              row={row}
              subColumns={store.subColumns}
              onEdit={onEditRowData}
              onDelete={onDeleteRowData}
              onEditMaturityDate={onEditMaturityDate}
              blankColumns={store.blankColumns || 0}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
);

export default InstallmentsTable;
